import { ReportFilter } from 'types';
import { useReportFilters } from '../../../../hooks';

export const useLateResponseFilters = (): ReportFilter[] => {
  const {
    consultationTypeIds,
    authorityIds,
    consultationCategoryIds,
    lateResponseReasonIds,
    responseTypeIds,
  } = useReportFilters();

  return [
    consultationTypeIds,
    authorityIds,
    consultationCategoryIds,
    lateResponseReasonIds,
    responseTypeIds,
  ];
};
